import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-norm35-step8',
  templateUrl: './norm35-step8.component.html',
  styleUrls: ['./norm35-step8.component.scss']
})
export class Norm35Step8Component implements OnInit {

  dataLink = [
    {
      idLink : "81",
      name  : '8.1 Para la prevención de los factores de riesgo psicosocial y la violencia laboral',
      ruta : './step8-sub1',
    },{
      idLink : "83",
      name : '8.3 Los centros de trabajo cuyo resultado de las evaluaciones a que se refieren los numerales 7.1 al 7.4 ',
      ruta : './step8-sub1-c)'
    },{
      idLink : "84",
      name  : '8.4 El Programa para la atención de los factores de riesgo psicosocial, y en su caso, para propiciar un entorno',
      ruta : './step8-sub4'
    },{
      idLink : "85",
      name  : '  8.5 El tipo de acciones deberán realizarse, según aplique, en los niveles siguientes',
      ruta : './step8-sub5',
    }
  ]

  dataSubLink = [
    {
      idSubLink : "81",
      name : '8.1 a) Establecer acciones para la prevención de los factores de riesgo psicosocial que impulsen',
      ruta : './step8-sub1-a)'
    },{
      idSubLink : "81",
      name  : '8.1 b) Disponer de mecanismos seguros y confidenciales para la recepción de quejas',
      ruta : './step8-sub1-b)'
    },{
      idSubLink : "81",
      name : '8.1 c) Realizar acciones que promuevan el sentido de pertenencia de los trabajadores a la organización',
      ruta : './step8-sub1-c'
    },{
      idSubLink : "85",
      name  : ' 8.5 a) Primer nivel ',
      ruta : './step8-sub5-a)'
    },{
      idSubLink : "85",
      name  : ' 8.5 b) Segundo nivel ',
      ruta : './step8-sub5-b)'
    },{
      idSubLink : "85",
      name  : ' 8.5 c) Tercer nivel ',
      ruta : './step8-sub5-c)'
    },
  ]

  constructor() { }

  ngOnInit() {
  }

}
